import { getPath } from '@/router/common'
import { getlqAssetsBaseUrl } from '@/utils/common'
const __lq_assets_base_url = getlqAssetsBaseUrl()
const baseUrl = {
  title: '登录',
  path: 'Account'
}
const SettlementUrl = {
  title: '登录',
  path: 'Settlement'
}

const MybSupplyManagement = {
  title: '登录',
  path: 'MybSupplyManagement'
}

const component = () => import(/* webpackChunkName: "Account_login" */ '@/views/account/login/index.vue')

// https://wiki.amh-group.com/pages/viewpage.action?pageId=748778759
export default [
  {
    path: getPath('Login', baseUrl),
    name: 'Account_Login',
    component,
    meta: {
      title: '蓝桥T9',
      bgUrl: `${__lq_assets_base_url}/Images/xt.png`, // 背景图url
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-logonew.png', // logo图url
      isAllowWxLogin: true, // 是否支持微信扫码登录
      isAllowSMSCheck: true, // 是否支持短信安全验证
      logincomefrom: 1 // 登录页类型，1.公版登录页  2.定制登录页
    }
  },
  {
    path: getPath('Login', SettlementUrl),
    name: 'Settlement_Login',
    component,
    meta: {
      title: '网络货运开票系统',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-kpgl_login_bg.jpg',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-logonew.png',
      logincomefrom: 1
    }
  },
  {
    path: getPath('Login', MybSupplyManagement),
    name: 'mybSupplyManagement_login',
    component,
    meta: {
      title: '网络货运开票系统',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-kpgl_login_bg.jpg',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-logonew.png',
      logincomefrom: 1
    }
  },
  {
    path: getPath('anytLogin', baseUrl),
    name: 'Account_anytLogin',
    component,
    meta: {
      title: '安能运通',
      bgUrl: `${__lq_assets_base_url}/Images/anytBg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/71c7b813-6ad8-4a90-877d-ad68358b2e92.png',
      logoStyle: 'width:100%;',
      isAllowSMSCheck: true
    }
  },
  {
    path: getPath('bdLogin', baseUrl),
    name: 'Account_bdLogin',
    component,
    meta: {
      title: '邦达物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/fa5e5a60-17fb-4798-8025-bede9c9d155d.png',
      bgUrl: `${__lq_assets_base_url}/Images/bangda_bg.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/e409f5d3-f950-421b-8326-267ead050405.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'left: 10%;right: auto;padding: 30px;'
    }
  },
  {
    path: getPath('ctLogin', baseUrl),
    name: 'Account_ctLogin',
    component,
    meta: {
      title: '传泰智慧物流供应链管理平台',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/e6e51382-4b67-4b50-b816-32e508430da1.png',
      bgUrl: `${__lq_assets_base_url}/Images/ct_bg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/b0fe0cde-ce0b-4d54-bc62-38441c8b3c73.png',
      logoStyle: 'width: 270px;'
    }
  },
  {
    path: getPath('dldLogin', baseUrl),
    name: 'Account_dldLogin',
    component,
    meta: {
      title: '蓝桥T9',
      bgUrl: `${__lq_assets_base_url}/Images/login_bg.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-login_logo2.png'
    }
  },
  {
    path: getPath('dssdLogin', baseUrl),
    name: 'Account_dssdLogin',
    component,
    meta: {
      title: '大顺顺达',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/32310750-6fbc-465e-b054-1c49c183f13b.png',
      bgUrl: `${__lq_assets_base_url}/Images/78995_bg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/d00d9211-8716-4cab-81df-ce7a84c67c14.png',
      logoStyle: 'width: 270px;'
    }
  },
  {
    path: getPath('hfLogin', baseUrl),
    name: 'Account_hfLogin',
    component,
    meta: {
      title: '合丰物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-79932_mini.jpg',
      bgUrl: `${__lq_assets_base_url}/Images/79932_bg.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-79932_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding: 30px;'
    }
  },
  {
    path: getPath('hhLogin', baseUrl),
    name: 'Account_hhLogin',
    component,
    meta: {
      title: '鸿皓物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-86583_mini.png',
      bgUrl: `${__lq_assets_base_url}/Images/86583_hh.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-86583_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding: 30px;'
    }
  },
  {
    path: getPath('hrLogin', baseUrl),
    name: 'Account_hrLogin',
    component,
    meta: {
      title: '恒瑞物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-80153_mini.png',
      bgUrl: `${__lq_assets_base_url}/Images/80153_bg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-80153_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'left: 10%;right: auto;padding: 30px;'
    }
  },
  {
    path: getPath('htLogin', baseUrl),
    name: 'Account_htLogin',
    component,
    meta: {
      title: '长远众邦达',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-88987_bg.jpg',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-88987_logo.png',
      logoStyle: 'width:100%;',
      loginStyle: 'padding: 30px;',
      loginImgStyle: 'height:60px;'
    }
  },
  {
    path: getPath('hxLogin', baseUrl),
    name: 'Account_hxLogin',
    component,
    meta: {
      title: '荟湘物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-hx86407_icon.png',
      bgUrl: `${__lq_assets_base_url}/Images/hx86407_bg.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-hx86407_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding: 30px;'
    }
  },
  {
    path: getPath('msLogin', baseUrl),
    name: 'Account_msLogin',
    component,
    meta: {
      title: '穆萨货运',
      bgUrl: `${__lq_assets_base_url}/Images/xt.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-80548_logo3.png',
      logoStyle: 'width:100%;',
      isAllowSMSCheck: true
    }
  },
  {
    path: getPath('shcjLogin', baseUrl),
    name: 'Account_shcjLogin',
    component,
    meta: {
      title: '上海创佳物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-86798_mini.png',
      bgUrl: `${__lq_assets_base_url}/Images/shcj_loginbg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-shcj_logo.png',
      logoStyle: 'width: 270px;height:70px;',
      loginStyle: 'position: absolute;top: 30%;left: 3%;margin-top: 0;'
    }
  },
  {
    path: getPath('shplLogin', baseUrl),
    name: 'Account_shplLogin',
    component,
    meta: {
      title: '上海普朗物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-shpl_logo.png',
      bgUrl: `${__lq_assets_base_url}/Images/shpl_loginbg.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-shpl_logo.png',
      logoStyle: 'width: 280px;',
      loginStyle: 'top: 36%;right: 3%;'
    }
  },
  {
    path: getPath('sjLogin', baseUrl),
    name: 'Account_sjLogin',
    component,
    meta: {
      title: '石金供应链',
      bgUrl: `${__lq_assets_base_url}/Images/xt.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-logonew.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding:30px;'
    }
  },
  {
    path: getPath('stlyLogin', baseUrl),
    name: 'Account_stlyLogin',
    component,
    meta: {
      title: '联友',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-stly_icon.png',
      bgUrl: `${__lq_assets_base_url}/Images/stly_bg.png`,
      maskTipsLogo: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-stly_logo.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-stly_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding:30px;'
    }
  },
  {
    path: getPath('szlydLogin', baseUrl),
    name: 'Account_szlydLogin',
    component,
    meta: {
      title: '林益达物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-90369_ico.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-89576_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'top: 30%;right: 6%;padding:30px 30px 40px;',
      isAllowSwiper: true,
      swiperImageList: [
        `${__lq_assets_base_url}/Images/szlyd_loginbg1.jpg`,
        `${__lq_assets_base_url}/Images/szlyd_loginbg2.jpg`,
        `${__lq_assets_base_url}/Images/szlyd_loginbg3.jpg`
      ],
      isHideLanQiao: true
    }
  },
  {
    path: getPath('tydfLogin', baseUrl),
    name: 'Account_tydfLogin',
    component,
    meta: {
      title: '天圆地方物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-90369_ico.png',
      bgUrl: `${__lq_assets_base_url}/Images/tydf_loginbg.jpg`,
      maskTipsLogo: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-tydf_logo.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-90369_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'top: 36%;right: 10%;padding:30px 30px 50px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('ydLogin', baseUrl),
    name: 'Account_ydLogin',
    component,
    meta: {
      title: '亚东国际货运',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-yadong_logo.png',
      bgUrl: `${__lq_assets_base_url}/Images/yadong_loginbg.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-yadong_logo.png',
      logoStyle: 'width: 270px;height:70px;'
    }
  },
  {
    path: getPath('yjtLogin', baseUrl),
    name: 'Account_yjtLogin',
    component,
    meta: {
      title: '元极泰供应链',
      iconUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-79566_mini.jpg`,
      bgUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-79566_bg.png`,
      logoUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-79566_mini.jpg`
    }
  },
  {
    path: getPath('ylaLogin', baseUrl),
    name: 'Account_ylaLogin',
    component,
    meta: {
      title: '雅利安供应链',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-81573_mini.png',
      bgUrl: `${__lq_assets_base_url}/Images/xt.png`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-81573_logo2.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding:30px;'
    }
  },
  {
    path: getPath('zlLogin', baseUrl),
    name: 'Account_zlLogin',
    component,
    meta: {
      title: '众力物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-80780_mini.png',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/Images-80780_bg.jpg',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-80780_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'padding:30px;',
      loginImgStyle: 'height: 90px;'
    }
  },
  {
    path: getPath('zwgjLogin', baseUrl),
    name: 'Account_zwgjLogin',
    component,
    meta: {
      title: '中物国际智慧供应链TMS',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-zhongwutitlelogo.png',
      bgUrl: `${__lq_assets_base_url}/Images/zhongwulogin.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-zhongwulogo.png',
      logoStyle: 'width: 270px;height:70px;'
    }
  },
  {
    path: getPath('szhxyLogin', baseUrl),
    name: 'Account_szhxyLogin',
    component,
    meta: {
      title: '鸿鑫宇物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-90369_ico.png',
      bgUrl: `${__lq_assets_base_url}/Images/szhxy_loginbg.png`,
      maskTipsLogo: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-91250_logo.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-91250_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'top: 36%;right: 10%;padding:30px 30px 50px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shxclLogin', baseUrl),
    name: 'Account_shxclLogin',
    component,
    meta: {
      title: '鑫春利物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-90369_ico.png',
      bgUrl: `${__lq_assets_base_url}/Images/shxcl_loginbg.jpg`,
      maskTipsLogo: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-91337_logo.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-91337_logo.png',
      logoStyle: 'width:100%;height:auto;',
      loginStyle: 'top: 36%;right: 10%;padding:30px 30px 50px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('dlwlLogin', baseUrl),
    name: 'Account_dlwlLogin',
    component,
    meta: {
      title: '东莞市大路物流有限公司',
      bgUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-dlwl_bg.jpg`,
      logoUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-91118logo.jpg`,
      logoStyle: 'width: 270px;'
    }
  },
  {
    path: getPath('ygwlLogin', baseUrl),
    name: 'account_ygwlLogin',
    component,
    meta: {
      title: '义乌市亿冠物流有限公司',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-favicon92032.png',
      bgUrl: `${__lq_assets_base_url}/Images/ygwl_loginbg.png`,
      maskTipsLogo: 'https://imagecdn.ymm56.com/ymmfile/static/resource/menuicon-LQ_logo.png',
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-ygwl92032.png',
      logoStyle: 'width: 280px;',
      loginStyle: 'right: 11%'
    }
  },
  {
    path: getPath('xnwlLogin', baseUrl),
    name: 'Account_xnwlLogin',
    component,
    meta: {
      title: '欣黎物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-yadong_logo.png',
      bgUrl: `${__lq_assets_base_url}/Images/backgroundImage92152.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO92152.jpg',
      logoStyle: 'height: 131px;',
      loginStyle: 'padding: 16px 30px;'
    }
  },
  {
    path: getPath('xjgylLogin', baseUrl),
    name: 'Account_xjgylLogin',
    component,
    meta: {
      title: '上海晓骏供应链',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO92890.png',
      bgUrl: `${__lq_assets_base_url}/Images/backgroundImage92890.jpg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO92890.png',
      logoStyle: 'height: 131px;',
      loginStyle: 'padding: 16px 30px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('cjhywlLogin', baseUrl),
    name: 'Account_cjhywlLogin',
    component,
    meta: {
      title: '重庆宏运物流有限公司',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO93731.png',
      bgUrl: `${__lq_assets_base_url}/Images/backgroundImage93731.jpeg`,
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO93731.png',
      logoStyle: 'height: 112px;',
      loginStyle: 'padding: 16px 30px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('bjhjkLogin', baseUrl),
    name: 'Account_bjhjkLogin',
    component,
    meta: {
      title: '北京宏景科运输服务有限公司',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-xiaoLOGO93922.png',
      bgUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-backgroundImage93922.jpg`,
      logoUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-LOGO93922Ago.png`,
      logoStyle: 'height: 102px;',
      loginStyle: 'padding: 16px 30px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('dfszyhxwxpLogin', baseUrl),
    name: 'Account_dfszyhxwxpLogin',
    component,
    meta: {
      title: '大丰市紫云化学危险品运输有限公司',
      bgUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/f6b2a1b3-0b9f-493d-aee8-a522a4540ca6.JPG`, // 背景图url
      logoUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/Images-logonew.png`,
      logoStyle: 'display: none;',
      loginStyle: 'padding: 16px 30px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('hcwlLogin', baseUrl),
    name: 'Account_hcwlLogin',
    component,
    meta: {
      title: '惠州海成供应链管理有限公司',
      iconUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-hcwl_logo.png`,
      bgUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/b5ab3fee-ccd5-4a7e-81e0-b8f38fa70539.png`, // 背景图url
      logoUrl: `https://imagecdn.ymm56.com/ymmfile/static/resource/LOGO-hcwl_logo.png`,
      logoStyle: 'height: 86px;',
      loginStyle: 'padding: 16px 30px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('ymkyLogin', baseUrl),
    name: 'Account_ymkyLogin',
    component,
    meta: {
      title: '云梦快运',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/6ab62965-4983-4efd-816a-588d4e25face.jpg',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/27c91e58-134e-4d6b-b17b-d55b5196890e.jpg', // 背景图url
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/747b2898-bd6e-4029-9142-5bb8a1d17225.jpg',
      logoStyle: 'height: 160px;',
      loginStyle: 'padding: 16px 30px;right: 10%',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('sywlLogin', baseUrl),
    name: 'Account_sywlLogin',
    component,
    meta: {
      title: '广州申扬物流',
      iconUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/2c7f8710-4072-4cf5-85f2-12a763dafdcb.jpg',
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/61bae60b-6d3e-46cb-a6d3-7abefb4cd505.jpg', // 背景图url
      logoUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/7ea0d4cb-8cf7-4728-a463-4d544b19b6d5.png',
      logoStyle: 'height: 160px;',
      loginStyle: 'padding: 16px 30px',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('jbnhkjLogin', baseUrl),
    name: 'Account_jbnhkjLogin',
    component,
    meta: {
      title: '山东京博农化科技',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/959380c1-b815-4382-b70e-139d18d6fb96.png",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/ef3f2546-41a9-49fe-a824-a01888bb2cfb.png', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/959380c1-b815-4382-b70e-139d18d6fb96.png",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shwjgjLogin', baseUrl),
    name: 'Account_shwjgjLogin',
    component,
    meta: {
      title: '上海威捷国际',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/c5d1457e-3c67-4c6d-9433-a2480331ca4a.jpg",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/3efe27e2-ee37-4c12-8888-af20e378b5f5.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/c5d1457e-3c67-4c6d-9433-a2480331ca4a.jpg",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('zjzswlLogin', baseUrl),
    name: 'Account_shwjgjLogin',
    component,
    meta: {
      title: '振胜物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/3c88660b-6a8c-4421-921e-ac221908c455.jpg",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/3c88660b-6a8c-4421-921e-ac221908c455.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/3c88660b-6a8c-4421-921e-ac221908c455.jpg",
      logoStyle: 'width: 100%; height: 160px;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shcfwlLogin', baseUrl),
    name: 'Account_shcfwlLogin',
    component,
    meta: {
      title: '创峰物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/2ad8ce81-531f-4304-80f1-bb6e02ff937b.png",
      bgUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/b584a864-c87f-4c6d-8ae3-eb515e823e16.jpg", // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/2ad8ce81-531f-4304-80f1-bb6e02ff937b.png",
      logoStyle: 'width: 100%; height: auto;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('tjydwlLogin', baseUrl),
    name: 'Account_tjydwlLogin',
    component,
    meta: {
      title: '天津远东物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/27e8644d-e77e-4b7e-9f56-9ec078418a84.png",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/80eeb54b-4241-41fa-b258-cd5c1fe031db.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/4eece2ba-b2b8-4c4f-948a-849f67fea26b.png",
      logoStyle: 'width: 100%; height: auto;',
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shlfwlLogin', baseUrl),
    name: 'Account_shlfwlLogin',
    component,
    meta: {
      title: '潞霏物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/4d94367a-a0e6-45d4-ad20-5778108ac2c0.jpg",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/7c5efd51-18dc-4171-99ec-672b2c9b7414.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/4d94367a-a0e6-45d4-ad20-5778108ac2c0.jpg",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('szywlLogin', baseUrl),
    name: 'Account_szywlLogin',
    component,
    meta: {
      title: '盛之阳物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/baf2af59-6d5e-49c0-8739-09a1e37a69d6.png",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/73eb6ef2-434f-4a16-8f48-c674e4b92646.png', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/baf2af59-6d5e-49c0-8739-09a1e37a69d6.png",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('sdsbzwgjLogin', baseUrl),
    name: 'Account_sdsbzwgjLogin',
    component,
    meta: {
      title: '中物国际',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/f55e19fa-ed7a-4364-a8e9-a4d2f0727226.jpg",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/3263bc5e-c12d-429b-9d62-b18a7483decc.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/f55e19fa-ed7a-4364-a8e9-a4d2f0727226.jpg",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('bycmwuliuLogin', baseUrl),
    name: 'Account_bycmwuliuLogin',
    component,
    meta: {
      title: '报业传媒发行物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/9a8e150f-7ffc-49fc-a056-e570579d0e24.png",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/21b8ba22-0061-4c65-b396-62c733df01df.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/9a8e150f-7ffc-49fc-a056-e570579d0e24.png",
    }
  },
  {
    path: getPath('hbdstLogin', baseUrl),
    name: 'Account_hbdstLogin',
    component,
    meta: {
      title: '大随通物流',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/22820414-457c-450e-b707-b2a039c8abc8.jpg",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/2f499319-dd3e-4f44-b9b9-324aae1e5c3b.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/22820414-457c-450e-b707-b2a039c8abc8.jpg",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shhhgylLogin', baseUrl),
    name: 'Account_shhhgylLogin',
    component,
    meta: {
      title: '上海华汇供应链',
      iconUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/4d984bb4-d17d-4b0f-8b1e-74b903e26bf2.png",
      bgUrl: 'https://imagecdn.ymm56.com/ymmfile/static/resource/89571176-9393-422e-add5-2a7b1313cd86.jpg', // 背景图url
      logoUrl: "https://imagecdn.ymm56.com/ymmfile/static/resource/4d984bb4-d17d-4b0f-8b1e-74b903e26bf2.png",
      isHideLanQiao: true
    }
  },
  {
    path: getPath('shjlwuliuLogin', baseUrl),
    name: 'Account_shjlwuliuLogin',
    component,
    meta: {
      title: '上海佳络物流',
      iconUrl: "https://files2.lqfast.com:28030/Files/Lq16888/20260116/e2e1683b-e80b-40bf-8719-dc8b49b0b82d.jpg",
      bgUrl: 'https://files2.lqfast.com:28030/Files/Lq16888/20260116/ba81ef5d-04e3-4aa1-b4c6-52b77140dcc6.jpg', // 背景图url
      logoUrl: "https://files2.lqfast.com:28030/Files/Lq16888/20260116/e2e1683b-e80b-40bf-8719-dc8b49b0b82d.jpg",
      isHideLanQiao: true
    }
  },
]
